import Shipping from "../views/Shipping/Shipping";
import ShippingInventory from "../views/Shipping/ShippingInventory";
import ShippingPicoShieldInventory from "../views/Shipping/ShippingPicoShieldInventory";
import ShippingDetail from "../views/Shipping/ShippingDetail";
import ShippingSummary from "../views/Shipping/ShippingSummary";
import ShippingPrintable from "../views/Shipping/ShippingPrintable";

export default [
  {
    path: "/Shipping/Requests",
    component: Shipping,
    name: "Shipping"
  },
  {
    path: "/Shipping/Inventory",
    component: ShippingInventory,
    name: "ShippingInventory"
  },
  {
    path: "/Shipping/PicoShield",
    component: ShippingPicoShieldInventory,
    name: "ShippingPicoShield"
  },
  {
    path: "/Shipping/:id",
    component: ShippingDetail,
    props: true,
    children: [
      {
        path: "Summary",
        name: "ShippingSummary",
        component: ShippingSummary,
        props: true
      },
      {
        path: "Print",
        name: "ShippingPrint",
        component: ShippingPrintable,
        props: true
      }
    ]
  },
]